// extracted by mini-css-extract-plugin
export var container = "Egg-module--container--8NHVW";
export var containerFlipped = "Egg-module--container-flipped--Icxoz";
export var containerWithFilledBottomRightCorner = "Egg-module--container-with-filled-bottom-right-corner--RftMg";